import {
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput as ChakraNumberInput,
    NumberInputField,
    NumberInputProps,
    NumberInputStepper,
} from '@chakra-ui/react';

const defaultStyles = { bg: 'white' as const };

type DrawerNumberInputProps = NumberInputProps;

export function DrawerNumberInput(props: DrawerNumberInputProps) {
    return (
        <ChakraNumberInput {...defaultStyles} {...props}>
            <NumberInputField />
            <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
            </NumberInputStepper>
        </ChakraNumberInput>
    );
}
